export default __webpack_public_path__ + "static/media/gallery_06.8e4e868a.jpg";